import React from "react";
import { useEffect, useState } from "react";
import useModalActions from "../../hooks/useModalActions";
import { MODAL_TYPES } from "../../utils/emitter";
import INTOUCH_API from "../../services/Api";
import {useTranslation} from "react-i18next";

export default function useController() {
  const [isFeedbackLoading, setIsFeedbackLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const { closeModal, openModal } = useModalActions();
  const { t } = useTranslation();
  const onSubmitHandle = async (event) => {
    setIsFeedbackLoading(true);
    event.preventDefault();

    const form = event.target;
    const text1 = form.text1?.value.trim();
    const text2 = form.text2?.value.trim();
    const text3 = form.text3?.value.trim();

    let feedbackText = "";

    if (!text1 || !text2 || !text3) {
      setIsError(true);
      setIsFeedbackLoading(false);
      return;
    }

    if (text1) {
      feedbackText += `1. ${t("feedback.label1")}\n${text1}\n`;
    }
    if (text2) {
      feedbackText += `2. ${t("feedback.label2")}\n${text2}\n`;
    }
    if (text3) {
      feedbackText += `3. ${t("feedback.label3")}\n${text3}\n`;
    }

    feedbackText = feedbackText.trim();

    await INTOUCH_API.requestManager(
      "feedback",
      {text: feedbackText},
      () => {
        form.text1.value = "";
        form.text2.value = "";
        form.text3.value = "";
      },
      () => {}
    ).finally(() => {
      setIsFeedbackLoading(false);
    });
    openModal(MODAL_TYPES.FEEDBACK_MODAL);
  };

  useEffect(() => {
    return () => {
      setIsFeedbackLoading(null);
    };
  });
  return {
    onSubmitHandle,
    isFeedbackLoading,
    isError
  };
}
